module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-news"
  }, [_c('img', {
    staticStyle: {
      "z-index": "-10",
      "position": "absolute"
    },
    attrs: {
      "src": "https://img.qiluyidian.net/shareimg20191216.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    ref: "tips",
    staticClass: "tips clearfix"
  }, [_c('span', {
    staticClass: "homeIcon",
    style: ({
      backgroundImage: _vm.home_url,
      backgroundSize: '100%'
    }),
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "rightLine"
  }), _vm._v(" "), _c('span', {
    staticClass: "slogon"
  }, [_vm._v("齐鲁晚报官方APP")]), _vm._v(" "), _c('span', {
    staticClass: "openApp",
    on: {
      "click": _vm.down
    }
  }, [_vm._v("打开")])]), _vm._v(" "), (_vm.loading == 0) ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: _vm.loading_url,
      backgroundSize: '20%'
    })
  }) : (_vm.loading == 1) ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: _vm.error_url,
      backgroundSize: '50%'
    })
  }) : (_vm.loading == 2) ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: _vm.deleted_url,
      backgroundSize: '50%'
    })
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.video), function(item, index) {
    return _c('div', {
      ref: "video",
      refInFor: true,
      staticClass: "videoWraper",
      class: {
        videoWraperF: index == 0
      }
    }, [_c('div', {
      staticClass: "videoAuthor clearfix"
    }, [(item.userImg) ? _c('img', {
      attrs: {
        "src": item.userImg,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../common/img/headImg.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.publishtime))])]), _vm._v(" "), _c('div', {
      staticClass: "video"
    }, [_c('video', {
      attrs: {
        "src": item.videourl,
        "height": "100%",
        "width": "100%",
        "poster": item.headimg,
        "x5-playsinline": "",
        "preload": "none",
        "playsinline": "",
        "webkit-playsinline": "",
        "controls": "controls",
        "loop": "loop"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "videoTitle"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "editor clearfix"
    }, [(item.columnName) ? _c('span', {
      staticClass: "tags"
    }, [_vm._v(_vm._s(item.columnName))]) : (item.ownername) ? _c('span', {
      staticClass: "tags"
    }, [_vm._v(_vm._s(item.ownername))]) : (item.source) ? _c('span', {
      staticClass: "tags"
    }, [_vm._v(_vm._s(item.source))]) : _vm._e(), _vm._v(" "), (item.praiseStatus) ? _c('span', {
      staticClass: "good clearfix",
      on: {
        "click": function($event) {
          return _vm.snap(item.newsId, index)
        }
      }
    }, [_c('span', {
      staticClass: "goodIcon",
      style: ({
        backgroundImage: _vm.good_url,
        backgroundSize: 'contain'
      })
    }), _vm._v(" "), (item.praisecount != '' && item.praisecount != 0) ? _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.praisecount))]) : _vm._e()]) : _c('span', {
      staticClass: "good clearfix",
      on: {
        "click": function($event) {
          return _vm.hasSnap(item.newsId, index)
        }
      }
    }, [_c('span', {
      staticClass: "goodIcon",
      style: ({
        backgroundImage: _vm.good_has_url,
        backgroundSize: 'contain'
      })
    }), _vm._v(" "), (item.praisecount != '' && item.praisecount != 0) ? _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.praisecount))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "comment clearfix",
      on: {
        "click": function($event) {
          return _vm.goCommentPage(item.newsId)
        }
      }
    }, [_c('span', {
      staticClass: "commentIcon",
      style: ({
        backgroundImage: _vm.comment_url,
        backgroundSize: 'contain'
      })
    }), _vm._v(" "), (item.commentcount != '' && item.commentcount != 0) ? _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.commentcount))]) : _vm._e()])])])
  }), _vm._v(" "), (_vm.allShow == 1) ? _c('div', {
    staticClass: "hotNewsAll"
  }, [_c('div', {
    staticClass: "appGoWrapper",
    on: {
      "click": function($event) {
        return _vm.down()
      }
    }
  }, [_c('p', {
    staticClass: "openAppGo"
  }, [_vm._v("打开壹点APP，查看更多视频")])])]) : _vm._e(), _vm._v(" "), (_vm.topShow) ? _c('div', {
    staticClass: "toTop"
  }, [_c('span', {
    staticClass: "index",
    style: ({
      backgroundImage: _vm.index_url,
      backgroundSize: 'contain'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHome.apply(null, arguments)
      }
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e555b90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/video/App.vue
// module id = 415
// module chunks = 11